export default "assets/images/feuille_1-e1ece725.png";